export default __webpack_public_path__ + "static/headstand-shoulderstrength-1-505768be53627a800fef433714792489.jpg";